/**
 * `cn` — Klassennamen konditional zusammenfügen (clsx-Lite).
 * Vendored-Shim für die appeulektro-Design-System-Primitives, die
 * `import { cn } from "~/lib/utils"` erwarteten. Kein Tailwind-Merge nötig,
 * die ds-* Klassen kollidieren nicht.
 */
export type ClassValue = string | number | null | false | undefined | ClassValue[];

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  const walk = (v: ClassValue) => {
    if (!v && v !== 0) return;
    if (Array.isArray(v)) v.forEach(walk);
    else out.push(String(v));
  };
  inputs.forEach(walk);
  return out.join(" ");
}
